import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//storestore
import useComnStore from 'src/webapp/stores/comn.store';
import usePartnerStore from 'src/webapp/stores/partner.store';
//style
import styles from 'src/asset/scss/style/dashboard.module.scss'
//hook
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
//comp
import EmptyData from 'src/webapp/views/component/EmptyData';//데이터없음

export default function ReservList(props) {
    const { type } = props;
    const { socket } = useComnStore();
    const navigator = useNavigate();//navigator
    const { axiosPostHandler } = useAxiosHook();//axios
    const { isState, partner } = usePartnerStore();
    const { reservCategoryFilter } = useComnHook();//예약점검카테고리
    
    /* =============== 당일 및 익일 예약내역리스트 =============== */
    const [ reservList,setReservList ] = useState([]);
    const reservListAPI = async() => {//type - 1.당일, 2.익일
        const DATA = { PARTNER_CD:partner.COMN_CD, TYPE:type };
        const result = await axiosPostHandler(`partnerReservDateListForPartner.do`, DATA);
        if(!result || result.message !== "SUCCESS") { return; }
        if(result.message === "SUCCESS") { 
            setReservList(result.data);
        }
    }
    useEffect(() => {(async () => {
        if(!isState) { return; }
    
        reservListAPI();
    })()}, [isState, socket]);
    /* =============== 당일 및 익일 예약내역리스트 =============== */
    /* =============== 스케줄리스트로 이동 =============== */
    const onLinkedHandler = () => {
        if(reservList.length <= 0 || reservList[0].RESERV_DT === undefined || reservList[0].RESERV_DT === null) { return; }

        navigator(`/schedule`, { state:reservList[0].RESERV_DT });
    }
    /* =============== 스케줄리스트로 이동 =============== */
    
    return (
        <div className={styles.reservListContainer}>
            <h1 onClick={(e) => onLinkedHandler()}><span>{type === 1 ? '당일' : type === 2 ? '익일' : null} 예약내역<FontAwesomeIcon icon="fa-light fa-chevron-right" /></span></h1>
            {reservList.length > 0 ?
                <ul>
                    {reservList.map((item, idx) => (
                        <li key={idx}>
                            <label style={{width:'5.25rem'}}>{item.MARKING_MEMBER_NAME}</label><hr />
                            <span style={{width:'7rem'}}>{item.CNT > 0 ? reservCategoryFilter(item.CATEGORY) + " 외" : reservCategoryFilter(item.CATEGORY)}</span><hr />
                            <span style={{width:'5.25rem'}}>{item.RESERV_TIME}</span><hr />
                            <span>{item.MODEL_KOR_NAME}</span>
                        </li>
                    ))}
                </ul>
            :   <EmptyData content={`예약내역은`} />}
        </div>
    );
}